<template>
  <accept-dialog
    :is-open-dialog="order && order.hasOwnProperty('uuid')"
    max-width="100%"
    @on-close="$emit('on-close')"
    @on-accept="$emit('on-accept', datesList)"
  >
    <div class="pt-6">
      <v-row>
        <v-col cols="12" md="6">
          <div class="d-flex">
            <v-date-picker
              v-model="datePart"
              scrollable
              locale="ru"
              actions
              :first-day-of-week="1"
            />

          </div>
          <div class="pt-2">
            <v-btn
              color="primary"
              elevation="2"
              large
              class="w-100"
              @click="addDate"
            >
              Добавить дату
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div
            v-for="(date, i) in datesList"
            class="d-flex mb-2"
            :key="date.format('YYYY-MM-DD')"
          >
            <div class="grow">
              {{ date.format('YYYY-MM-DD') }}
            </div>
            <div>
              <v-btn
                icon
                fab
                dark
                small
                color="pink"
                @click.prevent="datesList.splice(i, 1);"
              >
                <v-icon
                >mdi-trash-can-outline
                </v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </accept-dialog>
</template>

<script>
import AcceptDialog from '@/components/AcceptDialog.vue';
import moment from 'moment';

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export default {
  name: 'CloneModal',
  components: {
    AcceptDialog,
  },
  props: {
    order: {
      type: Object,
    },
  },
  data() {
    return {
      selectedDatetime: new Date(),
      datesList: [],
    };
  },
  computed: {
    datePart: {
      get() {
        return this.selectedDatetime ? moment(this.selectedDatetime)
          .format(DEFAULT_DATE_FORMAT) : '';
      },
      set(val) {
        this.dateSelected = true;
        this.activeTab = 1;
        const date = moment(val, DEFAULT_DATE_FORMAT);
        const hour = this.selectedDatetime ? moment(this.selectedDatetime)
          .hour() : 0;
        const minute = this.selectedDatetime ? moment(this.selectedDatetime)
          .minute() : 0;
        const input = moment()
          .year(date.year())
          .month(date.month())
          .date(date.date())
          .hour(hour)
          .minute(minute)
          .second(0);
        this.selectedDatetime = input.toDate();
      },
    },
    formattedDatetime() {
      return this.datetime ? moment(this.datetime)
        .format(this.format) : '';
    },
  },
  watch: {
    'order.uuid': {
      handler() {
        this.datesList = [];
      },
    },
  },
  methods: {
    addDate() {
      const newDate = moment(this.selectedDatetime);
      const duplicated = this.datesList
        .filter(date => newDate.format(DEFAULT_DATE_FORMAT) === date.format(DEFAULT_DATE_FORMAT));
      if (duplicated.length > 0) {
        alert('Такая дата уже существует в списке');
      } else {
        this.datesList.push(newDate);
      }
    },
  },
};
</script>

<style scoped>

</style>
